import { addWithDialog, addWithRedirect } from './addToNotifyMeList/loggedInUser';
import { redirect } from './addToNotifyMeList/guest';

export const addToNotifyMeListStrategies = {
    addWithRedirect,
    addWithDialog,
    redirect,
};
